import '@babel/polyfill'
import Vue from 'vue'
import moment from 'moment'
import './plugins/vuetify'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import store from './vuex/store'

axios.defaults.baseURL = process.env.VUE_APP_API_BACKEND;
export const bus = new Vue();

moment.locale('pt-BR')
Vue.config.productionTip = false

axios.interceptors.response.use((response) => {
  return response;
}, async (error) => {
  let requestConfig = error.config

  if (error.response.status === 403) {
    return store.dispatch('ativarRefreshToken').then(async s => {
      if (requestConfig.__tentativa == undefined) {
        requestConfig.__tentativa = 0;
      }
      if (s && requestConfig.__tentativa <= 3) {
        let newToken = JSON.parse(localStorage.getItem('usuarioLogado')).token
        requestConfig.headers.Authorization = `Bearer ${newToken}`
        store.state.loggedUser.token = newToken

        requestConfig.__tentativa = requestConfig.__tentativa + 1

        return axios(requestConfig)
      }
    })
  }
  return Promise.reject(error)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')